import React, { Component } from 'react';
import { history } from "../store/store";
import _ from "lodash";
import GobLogo from '../assets/images/gobmxlogo.svg';
import SecureLayout from "./secure";
import Notification from './../elements/notification';
import Navigation from "./../elements/navigation/navigation";
import UserDropdown from "../elements/user-opts-dropdown";
import Migrations from '../acervo/components/Sections/Main/Migrations'


export default function (SecuredComponent, data) {
	class AcervoLayout extends Component {

		render() {
			const { notifications, location, session, menu } = this.props;
			const { showModalMigrate } = this.state

			return [

				<Navigation agencies={{ ...session.user.agencies }} items={{ ...session.user.menu }} show={menu.view} location={{ ...location }} key={`app-navigation-sidebar`} />,

				<div className="main-content acervo" key="main-website-content">
					<nav className="navbar is-dark secondary-navigation">
						<div className="navbar-menu navbar-item">
							<img src={GobLogo} alt="gob.mx" className="app-gov-logo--image" />
						</div>
						<button className="main-nav--close" onClick={() => this.toggleMenu()}>
							{menu.view ? <i className="fa fa-chevron-left" /> : <i className="fa fa-chevron-right" />}
						</button>
						<UserDropdown data={{ ...session.user.profile }} />
					</nav>
					
					<section className="app-layout--content">
						<div className='hero'>
							<div className="columns is-vertical-center">
								<div className="column is-3">
									<h1 className="title is-1 main-title" dangerouslySetInnerHTML={{ __html: data && data.title ? data.title : '' }}></h1>
								</div>
								<div className="column is-2 is-offset-6 has-text-centered new-acervo">
									<button className="button is-fullwidth is-button-acervo is-uppercase" onClick={this._migrateAcervo}>
										<span className="icon"><i className="fa fa-plus"></i></span> migrar
                                    </button>
									<span className='subtitle-small is-fullwidth'>Entrega proyecto al acervo</span>
								</div>
							</div>
						</div>

						{notifications.active &&
							<div className="columns is-centered">
								<div className="column is-10-desktop">
									<Notification {...notifications} />
								</div>
							</div>}
						<div className="app-container">
							<SecuredComponent {...this.props} />
						</div>
						<div style={{ height: '50px' }}>&nbsp;</div>
						<Migrations {...this.props} visible={showModalMigrate} closeModal={this._closeModal} />
					</section>
				</div>
			]

		}

		constructor(props) {
			super(props);
			this.state = {
				profileShow: false,
				showState: props.match.params.state,
				showModalMigrate: false,
			}
			this.toggleMenu = this.toggleMenu.bind(this);
		}

		changeMuns(mun) {
			let url = _.split(history.location.pathname, '/', 6);
			if (url[4] === 'administrativo' || url[4] === 'juridica') {
				url[5] = this.state.showState;
				url[6] = mun;
			} else {
				url[4] = this.state.showState;
				url[5] = mun;
			}
			url = _.join(url, '/');
			history.push(url);
		}

		toggleMenu() {
			let { view } = this.props.menu;
			return view === true ? this.props.hideMenu() : this.props.showMenu();
		}

		_migrateAcervo = () => {
			this.setState({ showModalMigrate: true })
		}

		_closeModal = () => {
			this.setState({ showModalMigrate: false })
		}
	}
	return SecureLayout(AcervoLayout);
}



// WEBPACK FOOTER //
// ./src/templates/acervo.jsx